import { c } from 'ttag';

import { Button } from '@proton/atoms/Button/Button';
import ModalTwo from '@proton/components/components/modalTwo/Modal';
import ModalTwoContent from '@proton/components/components/modalTwo/ModalContent';
import ModalTwoFooter from '@proton/components/components/modalTwo/ModalFooter';
import ModalTwoHeader from '@proton/components/components/modalTwo/ModalHeader';

import { ImportType } from '../../../../interface';
import StepProductsRowItem from '../StepProducts/StepProductsRowItem';
import StepPrepareCalendarSummary from './StepPrepareOAuthCalendarSummary';
import StepPrepareContactsSummary from './StepPrepareOAuthContactsSummary';
import StepPrepareDescription from './StepPrepareOAuthDescription';
import StepPrepareDriveSummary from './StepPrepareOAuthDriveSummary';
import StepPrepareEmailsSummary from './StepPrepareOAuthEmailsSummary';
import StepPrepareErrorBox from './StepPrepareOAuthErrorBox';
import useStepPrepare from './hooks/useStepPrepareOAuth';

const StepPrepare = () => {
    const {
        emailChecked,
        setEmailChecked,
        contactChecked,
        setContactChecked,
        calendarChecked,
        setCalendarChecked,
        driveChecked,
        setDriveChecked,
        importerData,
        handleCancel,
        handleSubmit,
        hasErrors,
        emailTitle,
        products,
        allCheckboxUnselected,
    } = useStepPrepare();

    return (
        <ModalTwo size="xlarge" onClose={handleCancel} open>
            <ModalTwoHeader title={c('Title').t`Customize and confirm`} />
            <ModalTwoContent>
                <StepPrepareDescription />

                <StepPrepareErrorBox errors={hasErrors} />

                <div className="max-w-custom" style={{ '--max-w-custom': '30em' }}>
                    {products.includes(ImportType.MAIL) && (
                        <StepProductsRowItem
                            id="mail"
                            label={emailTitle}
                            value={emailChecked}
                            setValue={setEmailChecked}
                            error={importerData?.emails?.error}
                        >
                            <StepPrepareEmailsSummary isSelected={emailChecked} />
                        </StepProductsRowItem>
                    )}

                    {products.includes(ImportType.CONTACTS) && (
                        <StepProductsRowItem
                            id="contact"
                            label={c('Label').t`Contacts`}
                            value={contactChecked}
                            setValue={setContactChecked}
                            error={importerData?.contacts?.error}
                        >
                            <StepPrepareContactsSummary isSelected={contactChecked} />
                        </StepProductsRowItem>
                    )}

                    {products.includes(ImportType.CALENDAR) && (
                        <StepProductsRowItem
                            id="calendar"
                            label={c('Label').t`Calendar`}
                            value={calendarChecked}
                            setValue={setCalendarChecked}
                            error={importerData?.calendars?.error}
                        >
                            <StepPrepareCalendarSummary isSelected={calendarChecked} />
                        </StepProductsRowItem>
                    )}

                    {products.includes(ImportType.DRIVE) && (
                        <StepProductsRowItem
                            id="drive"
                            label={c('Label').t`Drive`}
                            value={driveChecked}
                            setValue={setDriveChecked}
                            error={importerData?.drive?.error?.message}
                        >
                            <StepPrepareDriveSummary isSelected={driveChecked} />
                        </StepProductsRowItem>
                    )}
                </div>
            </ModalTwoContent>
            <ModalTwoFooter>
                <Button shape="outline" onClick={handleCancel}>
                    {c('Action').t`Cancel`}
                </Button>
                <Button color="norm" onClick={handleSubmit} disabled={hasErrors || allCheckboxUnselected}>{c('Action')
                    .t`Start import`}</Button>
            </ModalTwoFooter>
        </ModalTwo>
    );
};

export default StepPrepare;
